<template>
  <div class="pp" @keydown.esc="open = false">
    <input
      v-model="q"
      class="pp-input"
      type="search"
      :placeholder="placeholder"
      autocomplete="off"
      @focus="open = true"
      @blur="onBlur"
      @keydown.down.prevent="move(1)"
      @keydown.up.prevent="move(-1)"
      @keydown.enter.prevent="pickHighlighted"
    >
    <ul v-if="open && filtered.length" class="pp-list">
      <li
        v-for="(p, i) in filtered"
        :key="p.id"
        class="pp-item"
        :class="{ 'is-on': i === hi }"
        @mousedown.prevent="pick(p)"
      >
        {{ p.label }}
      </li>
    </ul>
    <p v-else-if="open && q.trim() && !filtered.length" class="pp-empty">No people match</p>
  </div>
</template>

<script>
export default {
  name: 'AdminPersonPicker',
  props: {
    people: { type: Array, default: () => [] },
    excludeIds: { type: Array, default: () => [] },
    placeholder: { type: String, default: 'Add a dancer…' }
  },
  data () {
    return {
      q: '',
      open: false,
      hi: 0
    }
  },
  computed: {
    filtered () {
      const q = this.q.trim().toLowerCase()
      const skip = {}
      ;(this.excludeIds || []).forEach(id => {
        skip[id] = true
      })
      const out = []
      for (const p of this.people || []) {
        if (!p || !p.id || skip[p.id]) {
          continue
        }
        const hay = String(p.label || '').toLowerCase() + ' ' + String(p.email || '').toLowerCase()
        if (!q || hay.indexOf(q) !== -1) {
          out.push(p)
        }
        if (out.length >= 12) {
          break
        }
      }
      return out
    }
  },
  watch: {
    filtered () {
      this.hi = 0
    }
  },
  methods: {
    onBlur () {
      setTimeout(() => {
        this.open = false
      }, 120)
    },
    move (delta) {
      this.open = true
      const n = this.filtered.length
      if (!n) {
        return
      }
      this.hi = (this.hi + delta + n) % n
    },
    pickHighlighted () {
      const p = this.filtered[this.hi]
      if (p) {
        this.pick(p)
      }
    },
    pick (p) {
      this.$emit('select', p)
      this.q = ''
      this.open = false
    }
  }
}
</script>

<style scoped>
.pp {
  position: relative;
  min-width: 10rem;
}
.pp-input {
  width: 100%;
  box-sizing: border-box;
  padding: 6px 8px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font: inherit;
  background: #fff;
}
.pp-input:focus {
  outline: none;
  border-color: #388b9d;
  box-shadow: 0 0 0 2px rgba(56, 139, 157, 0.2);
}
.pp-list {
  position: absolute;
  z-index: 8;
  left: 0;
  right: 0;
  margin: 2px 0 0;
  padding: 4px 0;
  list-style: none;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  max-height: 220px;
  overflow: auto;
}
.pp-item {
  padding: 6px 10px;
  cursor: pointer;
}
.pp-item:hover,
.pp-item.is-on {
  background: #eef6f6;
}
.pp-empty {
  position: absolute;
  z-index: 8;
  left: 0;
  right: 0;
  margin: 2px 0 0;
  padding: 8px 10px;
  font-size: 12px;
  color: #777;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
}
</style>
